import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  CreateButton,
  Edit,
  Create,
  SimpleForm,
  EditButton,
  DeleteButton,
  TopToolbar,
  QuickFilter, Pagination,
} from 'react-admin';
import { ImportButton } from "react-admin-import-csv";

const translationFilters = [
  <TextInput source="english__like" label="English" alwaysOn />,
  <TextInput source="fr__like" label="Français" />,
  <TextInput source="es__like" label="Español" />,
  <TextInput source="de__like" label="Deutsch" />,
  <TextInput source="th__like" label="ภาษาไทย" />,
  <TextInput source="zh__like" label="中文" />,
];

const importOptions = {
  parseConfig: {
    // For all options see: https://www.papaparse.com/docs#config
    dynamicTyping: true
  }
}

const TranslationPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100, 250, 500, 1000]} {...props} />;
const ListActions = (props) => {
  const { className, basePath } = props;
  return (
    <TopToolbar className={className}>
      <CreateButton basePath={basePath} />
      <ImportButton {...props} {...importOptions} />
    </TopToolbar>
  );
};
export const TranslationList = props => (
  <List {...props} filters={translationFilters} pagination={<TranslationPagination/>} actions={<ListActions />}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="english" />
      <TextField source="zh" />
      <TextField source="fr" />
      <TextField source="es" />
      <TextField source="de" />
      <TextField source="th" />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);

export const TranslationEdit = props => (
  <Edit title='Edit Translation' {...props}>
    <SimpleForm>
      <TextInput disabled source="id" />
      <TextInput source="english" />
      <TextInput source="zh" />
      <TextInput source="fr" />
      <TextInput source="es" />
      <TextInput source="de" />
      <TextInput source="th" />
    </SimpleForm>
  </Edit>
);

export const TranslationCreate = props => (
  <Create title='Create Translation' {...props}>
    <SimpleForm>
      <TextInput source="english" />
      <TextInput source="zh" />
      <TextInput source="fr" />
      <TextInput source="es" />
      <TextInput source="de" />
      <TextInput source="th" />
    </SimpleForm>
  </Create>
);
